'use strict';

const KEY_ORDER = 'cache_orders',
  { t } = require('services/i18nextWrapper'),
  KEY_TANK = 'cache_tanks',
  KEY_DRAFT = 'cache_draft',
  KEY_ITEMS = 'cache_items',
  KEY_LOCATIONS = 'cache_locations',
  KEY_BREW_PROCESS = 'cache_brew_process',
  KEY_FERMENTING_PROCESS = 'cache_fermenting_process',
  KEY_PACKAGING_PROCESS = 'cache_packaging_process',
  KEY_VENDOR_PURCHASE_ITEMS = 'cache_vendor_purchase_items',
  KEY_DRAFT_ORDER_AMOUNT = 'cache_draft_order_amount',
  KEY_UNDO_DRAFT_ORDER_AMOUNT = 'cache_undo_draft_order_amount',
  KEY_BEER_STYLE = 'cache_beerstyle',
  CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
  KEY_BEER_STYLE_TASK_CONFIGURATIONS = 'cache_beerstyle_task_configurations',
  _ = require('lodash'),
  get = require('lodash/object').get,
  {
    FERMENTER_TYPE_TASK,
    PACKAGING_TYPE_TASK,
    BREWING_TYPE_TASK,
    MAX_DRAFT_OPERATION,
    KEY_VENDOR_ITEMS
  } = require('constants/AppConstants'),
  SessionStore = require('stores/SessionStore'),
  DashboardAction = require('../actions/DashboardActionCreators'),
  Constants = require('constants/AppConstants'),
  DashboardLayoutStore = require('stores/DashboardLayoutStore'),
  ChronologycServiceCache = require('./ChronologycServiceCache'),
  NumberUtils = require('utils/NumberUtils'),
  DateUtils = require('utils/DateUtils'),
  moment = require('moment'),
  ContentUtils = require('utils/ContentUtils');

const DashboardServiceCache = {

  /**
   * We create the following legacy retriever method, in order to not show into the dashboard de broken image icon.
   */
  getFermenterIconsWithLegacy() {
    return [
      {
        tankType: 'FV',
        name: Constants.TASK_NON_VISIBLE,
        displayName: Constants.TASK_NON_VISIBLE
      },
      {
        tankType: 'FV',
        name: 'Yeast New Pitch',
        displayName: t('dashboard_service_cache_name_yeast_new_pitch'),
        src: '/assets/images/yeast-new-pitch.svg',
        icon: 'icon-task icon-yeast-new-pitch'
      },
      {
        tankType: 'FV',
        name: 'Yeast In',
        displayName: t('dashboard_service_cache_name_yeast_in_from'),
        src: '/assets/images/yeast-in.svg',
        icon: 'icon-task yeast-in icon-yeast-in'
      },
      {
        tankType: 'FV',
        name: 'Yeast Out',
        displayName: t('dashboard_service_cache_name_yeast_out'),
        src: '/assets/images/yeast-out.svg',
        icon: 'icon-task yeast-out icon-yeast-out'
      },
      {
        tankType: 'FV',
        name: 'Yeast From',
        displayName: t('dashboard_service_cache_name_yeast_from'),
        src: '/assets/images/yeast-from.svg',
        icon: 'icon-task yeast-from icon-yeast-from'
      },
      {
        tankType: 'FV',
        name: 'Yeast Harvest',
        displayName: t('dashboard_service_cache_name_yeast_harvest'),
        src: '/assets/images/yeast_harvest.svg',
        icon: 'icon-task icon-yeast-harvest'
      },

      {
        tankType: 'FV',
        name: 'Yeast Drain',
        displayName: t('dashboard_service_cache_name_yeast_drain'),
        src: '/assets/images/yeast_drain.svg',
        icon: 'icon-task icon-yeast-drain'
      },
      {
        tankType: 'FV',
        name: 'Fining or Enzymes',
        displayName: t('dashboard_service_cache_name_finish_enzymes'),
        src: '/assets/images/fining_enzymes_etc.svg',
        icon: 'icon-task icon-fining-enzymes-etc'
      },
      {
        tankType: 'FV',
        name: 'Dry Hopping',
        displayName: t('dashboard_service_cache_name_dry_hopping'),
        src: '/assets/images/dry_hopping.svg',
        icon: 'icon-task icon-dry-hopping'
      },
      {
        tankType: 'FV',
        name: 'DY and DH',
        displayName: t('dashboard_service_cache_name_dy_and_dh'),
        src: '/assets/images/dy_and_dh.svg',
        icon: 'icon-task icon-dy-and-dh'
      },
      {
        tankType: 'FV',
        name: Constants.DEFAULT_TASK_BREWING,
        displayName: Constants.DEFAULT_TASK_BREWING,
        src: '/assets/images/brew.svg',
        icon: 'icon-task icon-brewing'
      },
      {
        tankType: 'FV',
        name: 'Fruit',
        displayName: t('dashboard_service_cache_name_fruit'),
        src: '/assets/images/fruit.svg',
        icon: 'icon-task icon-fruit'
      },
      {
        tankType: 'FV',
        name: 'Pumpkin',
        displayName: t('dashboard_service_cache_name_pumpkin'),
        src: '/assets/images/pumpkin.svg',
        icon: 'icon-task icon-pumpkin'
      },
      {
        tankType: 'FV',
        name: 'Honey',
        displayName: t('dashboard_service_cache_name_honey'),
        src: '/assets/images/honey.svg',
        icon: 'icon-task icon-honey'
      },
      {
        tankType: 'FV',
        name: 'Coffee Bean',
        displayName: t('dashboard_service_cache_name_coffee_bean'),
        src: '/assets/images/coffee-bean.svg',
        icon: 'icon-task icon-coffee-bean'
      },
      {
        tankType: 'FV',
        name: 'Cooling',
        displayName: t('dashboard_service_cache_name_cooling'),
        src: '/assets/images/cooling.svg',
        icon: 'icon-task icon-cooling'
      },
      {
        tankType: 'FV',
        name: 'Temperature',
        displayName: t('dashboard_service_cache_name_temperature'),
        src: '/assets/images/temperature.svg',
        icon: 'icon-task icon-temperature'
      },
      {
        tankType: 'FV',
        name: 'Firkin',
        displayName: t('dashboard_service_cache_name_firkin'),
        src: '/assets/images/firkin.svg',
        icon: 'icon-task icon-firkin'
      },
      {
        tankType: 'FV',
        name: 'Keg',
        displayName: t('dashboard_service_cache_keg'),
        src: '/assets/images/keg.svg',
        icon: 'icon-task icon-keg'
      },
      {
        tankType: 'FV',
        name: 'Wood Barrel',
        displayName: t('dashboard_service_cache_name_wood_barrel'),
        src: '/assets/images/wood_barrel.svg',
        icon: 'icon-task icon-wood-barrel'
      },
      {
        tankType: 'FV',
        name: 'Tote',
        displayName: t('dashboard_service_cache_name_tote'),
        src: '/assets/images/tote.svg',
        icon: 'icon-task icon-tote'
      },
      {
        tankType: 'FV',
        name: 'Repair',
        displayName: t('dashboard_service_cache_name_repair'),
        src: '/assets/images/repair.svg',
        icon: 'icon-task icon-repair'
      },
      {
        tankType: 'FV',
        name: 'Report Problem',
        displayName: t('dashboard_service_cache_name_report_problem'),
        src: '/assets/images/report_problem.svg',
        icon: 'icon-task icon-report-problem'
      },
      {
        tankType: 'FV',
        name: 'class_meeting',
        displayName: t('dashboard_service_cache_name_class_or_meeting'),
        src: '/assets/images/class.svg',
        icon: 'icon-task icon-class-meeting'
      },
      {
        tankType: 'FV',
        name: t('dashboard_service_cache_name_note'),
        displayName: 'Note',
        src: '/assets/images/ic_email_white_18px.svg',
        icon: 'icon-task icon-email'
      },
      {
        tankType: 'FV',
        name: 'Cleaning',
        displayName: t('dashboard_service_cache_name_cleaning'),
        src: '/assets/images/cleaning.svg',
        icon: 'icon-task icon-cleaning'
      },
      {
        tankType: 'FV',
        name: 'Transfer',
        displayName: t('dashboard_service_cache_name_transfer'),
        src: '/assets/images/transfer.svg',
        icon: 'icon-task icon-transfer'
      },
      {
        tankType: 'FV',
        name: 'Centrifuge',
        displayName: t('dashboard_service_cache_name_centrifuge'),
        src: '/assets/images/centrifuge.svg',
        icon: 'icon-task icon-centrifuge'
      },
      {
        tankType: 'FV',
        name: Constants.DEFAULT_TASK_FILTRATION,
        displayName: Constants.DEFAULT_TASK_FILTRATION,
        src: '/assets/images/filtration.svg',
        icon: 'icon-task icon-filtration'
      },
      {
        tankType: 'FV',
        name: 'Column still',
        displayName: t('dashboard_service_cache_name_column_still'),
        src: '/assets/images/column_still_white.svg',
        icon: 'icon-task icon-column-still'
      },
      {
        tankType: 'FV',
        name: 'Pot still',
        displayName: t('dashboard_service_cache_name_pot_still'),
        src: '/assets/images/pot_still_white.svg',
        icon: 'icon-task icon-pot-still'
      },

      // Legacy ---------------------------------------------

      {
        tankType: 'FV',
        name: 'Brew & yeast',
        displayName: t('dashboard_service_cache_name_brew_yeast'),
        src: '/assets/images/brew_and_yeast.svg',
        icon: 'icon-task icon-brew-and-yeast',
        isDiscontinued: true
      },
      {
        tankType: 'FV',
        name: 'Brew & Flask',
        displayName: t('dashboard_service_cache_name_brew_flask'),
        src: '/assets/images/brew_and_flask.svg',
        icon: 'icon-task icon-brew-and-flask',
        isDiscontinued: true
      },
      {
        tankType: 'FV',
        name: 'Filter and Brew',
        displayName: t('dashboard_service_cache_name_filter_brew'),
        src: '/assets/images/filter_and_brew_black.svg',
        icon: 'icon-task icon-filter-and-brew-black',
        isDiscontinued: true
      },
      {
        tankType: 'FV',
        name: 'Brew Day Before',
        displayName: t('dashboard_service_cache_name_brew_day_before'),
        src: '/assets/images/brew_day_before.svg',
        icon: 'icon-task icon-brew-day-before',
        isDiscontinued: true
      }
    ];
  },
  getPackagingIconsWithLegacy() {
    return [
      {
        tankType: 'BT',
        displayName: Constants.TASK_NON_VISIBLE,
        name: Constants.TASK_NON_VISIBLE
      },
      {
        tankType: 'BT',
        name: 'Bottle',
        displayName: t('dashboard_service_cache_name_bottle'),
        src: '/assets/images/bottle.svg',
        icon: 'icon-task icon-bottle'
      },
      {
        tankType: 'BT',
        name: 'Can',
        displayName: t('dashboard_service_cache_name_can'),
        src: '/assets/images/can.svg',
        icon: 'icon-task icon-can'
      },
      {
        tankType: 'BT',
        name: 'Keg',
        displayName: t('dashboard_service_cache_keg'),
        src: '/assets/images/keg.svg',
        icon: 'icon-task icon-keg'
      },
      {
        tankType: 'BT',
        name: 'Box',
        displayName: t('dashboard_service_cache_name_box'),
        src: '/assets/images/box.svg',
        icon: 'icon-task icon-box'
      },
      {
        tankType: 'BT',
        name: 'Bottle & keg',
        displayName: t('dashboard_service_cache_name_bottle_keg'),
        src: '/assets/images/bottle_and_keg.svg',
        icon: 'icon-task icon-bottle-and-keg'
      },
      {
        tankType: 'BT',
        name: 'Can & Keg',
        displayName: t('dashboard_service_cache_name_can_keg'),
        src: '/assets/images/can_and_keg.svg',
        icon: 'icon-task icon-can-and-keg'
      },
      {
        tankType: 'BT',
        name: 'Can & Bottle',
        displayName: t('dashboard_service_cache_name_can_bottle'),
        src: '/assets/images/can_and_bottle.svg',
        icon: 'icon-task icon-can-and-bottle'
      },
      {
        tankType: 'BT',
        name: 'Can & Box',
        displayName: t('dashboard_service_cache_name_can_box'),
        src: '/assets/images/can_and_box.svg',
        icon: 'icon-task icon-can-and-box'
      },
      {
        tankType: 'BT',
        name: 'Bottle Pack',
        displayName: t('dashboard_service_cache_name_bottle_pack'),
        src: '/assets/images/bottle_pack.svg',
        icon: 'icon-task icon-bottle-pack'
      },
      {
        tankType: 'BT',
        name: 'No Pack',
        displayName: t('dashboard_service_cache_name_no_pack'),
        src: '/assets/images/no_pack.svg',
        icon: 'icon-task icon-no-pack'
      },
      {
        tankType: 'BT',
        name: 'Mix Box',
        displayName: t('dashboard_service_cache_name_mix_box'),
        src: '/assets/images/mix-box.svg',
        icon: 'icon-task icon-mix-box'
      },
      {
        tankType: 'BT',
        name: Constants.DEFAULT_TASK_PACKAGING,
        displayName: Constants.DEFAULT_TASK_PACKAGING,
        src: '/assets/images/packaging.svg',
        icon: 'icon-task icon-packaging'
      },
      {
        tankType: 'BT',
        name: 'Co2',
        displayName: t('dashboard_service_cache_name_co2'),
        src: '/assets/images/co2.svg',
        icon: 'icon-task icon-co2'
      },
      {
        tankType: 'BT',
        name: 'Receiving Truck',
        displayName: t('dashboard_service_cache_name_receiving_truck'),
        src: '/assets/images/receiving-truck.svg',
        icon: 'icon-task icon-receiving-truck'
      },
      {
        tankType: 'BT',
        name: 'Shipping Truck',
        displayName: t('dashboard_service_cache_name_shipping_truck'),
        src: '/assets/images/shipping-truck.svg',
        icon: 'icon-task icon-shipping-truck'
      },

      {
        tankType: 'BT',
        name: 'Fruit',
        displayName: t('dashboard_service_cache_name_fruit'),
        src: '/assets/images/fruit.svg',
        icon: 'icon-task icon-fruit'
      },
      {
        tankType: 'BT',
        name: 'Pumpkin',
        displayName: t('dashboard_service_cache_name_pumpkin'),
        src: '/assets/images/pumpkin.svg',
        icon: 'icon-task icon-pumpkin'
      },

      {
        tankType: 'BT',
        name: 'Honey',
        displayName: t('dashboard_service_cache_name_honey'),
        src: '/assets/images/honey.svg',
        icon: 'icon-task icon-honey'
      },
      {
        tankType: 'BT',
        name: 'Coffee Bean',
        displayName: t('dashboard_service_cache_name_coffee_bean'),
        src: '/assets/images/coffee-bean.svg',
        icon: 'icon-task coffee-bean'
      },
      {
        tankType: 'BT',
        name: 'Cooling',
        displayName: t('dashboard_service_cache_name_cooling'),
        src: '/assets/images/cooling.svg',
        icon: 'icon-task icon-cooling'
      },
      {
        tankType: 'BT',
        name: 'Temperature',
        displayName: t('dashboard_service_cache_name_temperature'),
        src: '/assets/images/temperature.svg',
        icon: 'icon-task icon-temperature'
      },
      {
        tankType: 'BT',
        name: 'Firkin',
        displayName: t('dashboard_service_cache_name_firkin'),
        src: '/assets/images/firkin.svg',
        icon: 'icon-task icon-firkin'
      },
      {

        tankType: 'BT',
        name: 'Wood Barrel',
        displayName: t('dashboard_service_cache_name_wood_barrel'),
        src: '/assets/images/wood_barrel.svg',
        icon: 'icon-task icon-wood-barrel'
      },
      {
        tankType: 'BT',
        name: 'Tote',
        displayName: t('dashboard_service_cache_name_tote'),
        src: '/assets/images/tote.svg',
        icon: 'icon-task icon-tote'
      },
      {
        tankType: 'BT',
        name: 'Repair',
        displayName: t('dashboard_service_cache_name_repair'),
        src: '/assets/images/repair.svg',
        icon: 'icon-task icon-repair'
      },
      {
        tankType: 'BT',
        name: 'Report Problem',
        displayName: t('dashboard_service_cache_name_report_problem'),
        src: '/assets/images/report_problem.svg',
        icon: 'icon-task icon-report-problem'
      },
      {
        tankType: 'BT',
        name: 'class_meeting',
        displayName: t('dashboard_service_cache_name_class_or_meeting'),
        src: '/assets/images/class.svg',
        icon: 'icon-task icon-class-meeting'
      },
      {
        tankType: 'BT',
        name: 'Note',
        displayName: t('dashboard_service_cache_name_note'),
        src: '/assets/images/ic_email_white_18px.svg',
        icon: 'icon-task icon-email'
      },
      {
        tankType: 'BT',
        name: 'Cleaning',
        displayName: t('dashboard_service_cache_name_cleaning'),
        src: '/assets/images/cleaning.svg',
        icon: 'icon-task icon-cleaning'
      },
      {
        tankType: 'BT',
        name: 'Transfer',
        displayName: t('dashboard_service_cache_name_transfer'),
        src: '/assets/images/transfer.svg',
        icon: 'icon-task icon-transfer'
      },
      {
        tankType: 'BT',
        name: 'Centrifuge',
        displayName: t('dashboard_service_cache_name_centrifuge'),
        src: '/assets/images/centrifuge.svg',
        icon: 'icon-task icon-centrifuge'
      },
      {
        tankType: 'BT',
        name: 'Fining or Enzymes',
        displayName: t('dashboard_service_cache_name_finish_enzymes'),
        src: '/assets/images/fining_enzymes_etc.svg',
        icon: 'icon-task icon-fining-enzymes-etc'
      },
      {
        tankType: 'BT',
        name: Constants.DEFAULT_TASK_FILTRATION,
        displayName: Constants.DEFAULT_TASK_FILTRATION,
        src: '/assets/images/filtration.svg',
        icon: 'icon-task icon-filtration'
      },

      {
        tankType: 'BT',
        name: 'Column still',
        displayName: t('dashboard_service_cache_name_column_still'),
        src: '/assets/images/column_still_white.svg',
        icon: 'icon-task icon-column-still'
      },
      {
        tankType: 'BT',
        name: 'Pot still',
        displayName: t('dashboard_service_cache_name_pot_still'),
        src: '/assets/images/pot_still_white.svg',
        icon: 'icon-task icon-pot-still'
      }

      // Legacy --------------------
    ];
  },
  getBrewhouseIconsWithLegacy() {
    return [
      {
        tankType: 'BH',
        name: Constants.TASK_NON_VISIBLE,
        displayName: Constants.TASK_NON_VISIBLE
      },
      {
        tankType: 'BH',
        name: Constants.DEFAULT_TASK_BREWING,
        displayName: Constants.DEFAULT_TASK_BREWING,
        src: '/assets/images/brew.svg',
        icon: 'icon-task icon-brewing'
      },
      {
        tankType: 'BH',
        name: 'Brew & CIP',
        displayName: t('dashboard_service_cache_name_brew_cip'),
        src: '/assets/images/brew-&-cip.svg',
        icon: 'icon-task icon-brew-and-cip'
      },

      {
        tankType: 'BH',
        name: 'Bew & O2',
        displayName: t('dashboard_service_cache_name_brew_o2'),
        src: '/assets/images/brew-&-o2.svg',
        icon: 'icon-task icon-brew-and-o2'
      },
      {
        tankType: 'BH',
        name: 'Bew, CIP & O2',
        displayName: t('dashboard_service_cache_name_brew_cip_o2'),
        src: '/assets/images/brew-cip-&-o2.svg',
        icon: 'icon-task icon-brew-cip-and-o2'
      },
      {
        tankType: 'BH',
        name: 'Fruit',
        displayName: t('dashboard_service_cache_name_fruit'),
        src: '/assets/images/fruit.svg',
        icon: 'icon-task icon-fruit'
      },
      {
        tankType: 'BH',
        name: 'Pumpkin',
        displayName: t('dashboard_service_cache_name_pumpkin'),
        src: '/assets/images/pumpkin.svg',
        icon: 'icon-task icon-pumpkin'
      },
      {
        tankType: 'BH',
        name: 'Honey',
        displayName: t('dashboard_service_cache_name_honey'),
        src: '/assets/images/honey.svg',
        icon: 'icon-task icon-honey'
      },

      {
        tankType: 'BH',
        name: 'Coffee Bean',
        displayName: t('dashboard_service_cache_name_coffee_bean'),
        src: '/assets/images/coffee-bean.svg',
        icon: 'icon-task coffee-bean'
      },
      {
        tankType: 'BH',
        name: 'Cooling',
        displayName: t('dashboard_service_cache_name_cooling'),
        src: '/assets/images/cooling.svg',
        icon: 'icon-task icon-cooling'
      },
      {
        tankType: 'BH',
        name: 'Temperature',
        displayName: t('dashboard_service_cache_name_temperature'),
        src: '/assets/images/temperature.svg',
        icon: 'icon-task icon-temperature'
      },
      {
        tankType: 'BH',
        name: 'Firkin',
        displayName: t('dashboard_service_cache_name_firkin'),
        src: '/assets/images/firkin.svg',
        icon: 'icon-task icon-firkin'
      },

      {
        tankType: 'BH',
        name: 'Wood Barrel',
        displayName: t('dashboard_service_cache_name_wood_barrel'),
        src: '/assets/images/wood_barrel.svg',
        icon: 'icon-task icon-wood-barrel'
      },
      {
        tankType: 'BH',
        name: 'Tote',
        displayName: t('dashboard_service_cache_name_tote'),
        src: '/assets/images/tote.svg',
        icon: 'icon-task icon-tote'
      },
      {
        tankType: 'BH',
        name: 'Repair',
        displayName: t('dashboard_service_cache_name_repair'),
        src: '/assets/images/repair.svg',
        icon: 'icon-task icon-repair'
      },
      {
        tankType: 'BH',
        name: 'Report Problem',
        displayName: t('dashboard_service_cache_name_report_problem'),
        src: '/assets/images/report_problem.svg',
        icon: 'icon-task icon-report-problem'
      },
      {
        tankType: 'BH',
        name: 'class_meeting',
        displayName: t('dashboard_service_cache_name_class_or_meeting'),
        src: '/assets/images/class.svg',
        icon: 'icon-task icon-class-meeting'
      },
      {
        tankType: 'BH',
        name: 'Note',
        displayName: t('dashboard_service_cache_name_note'),
        src: '/assets/images/ic_email_white_18px.svg',
        icon: 'icon-task icon-email'
      },
      {
        tankType: 'BH',
        name: 'Cleaning',
        displayName: t('dashboard_service_cache_name_cleaning'),
        src: '/assets/images/cleaning.svg',
        icon: 'icon-task icon-cleaning'
      },
      {
        tankType: 'BH',
        name: 'Transfer',
        displayName: t('dashboard_service_cache_name_transfer'),
        src: '/assets/images/transfer.svg',
        icon: 'icon-task icon-transfer'
      },
      {
        tankType: 'BH',
        name: 'Column still',
        displayName: t('dashboard_service_cache_name_column_still'),
        src: '/assets/images/column_still_white.svg',
        icon: 'icon-task icon-column-still'
      },
      {
        tankType: 'BH',
        name: 'Pot still',
        displayName: t('dashboard_service_cache_name_pot_still'),
        src: '/assets/images/pot_still_white.svg',
        icon: 'icon-task icon-pot-still'
      }
    ];
  },

  getCustomBrewingIcons() {
    const mapping = Constants.getIconsMapping(t);
    const brewingIcons = _.filter(ContentUtils.getSession(Constants.KEY_CUSTOM_ICONS), icon => _.get(icon, 'iconDetail.isBrewingAllowed'));
    return _.map(brewingIcons, icon => this._toIcon(icon, { tankType: 'BH' }, mapping)).sort((a, b) => {
      const idA = get(a, 'id');
      const idB = get(b, 'id');
      const displayNameA = get(a, 'displayName');
      const displayNameB = get(b, 'displayName');

      // Keep the object with id 1 at the start
      if (idA === 1) {
          return -1; // Keep a before b
      } else if (idB === 1) {
          return 1; // Move b before a
      } else {
          // Sort the rest alphabetically by display name
          return displayNameA.localeCompare(displayNameB);
      }
    });
  },

  getCustomFermenterIcons() {
    const mapping = Constants.getIconsMapping(t);
    const fermenterIcons = _.filter(ContentUtils.getSession(Constants.KEY_CUSTOM_ICONS), icon => _.get(icon, 'iconDetail.isFermentingAllowed'));
    
    return _.map(fermenterIcons, icon => this._toIcon(icon, { tankType: 'BH' }, mapping)).sort((a, b) => {
        const idA = get(a, 'id');
        const idB = get(b, 'id');
        const displayNameA = get(a, 'displayName');
        const displayNameB = get(b, 'displayName');

        // Keep the object with id 1 at the start
        if (idA === 1) {
            return -1; // Keep a before b
        } else if (idB === 1) {
            return 1; // Move b before a
        } else {
            // Sort the rest alphabetically by display name
            return displayNameA.localeCompare(displayNameB);
        }
    });
  },

  getCustomPackagingIcons() {
    const mapping = Constants.getIconsMapping(t);
    const packagingIcons = _.filter(ContentUtils.getSession(Constants.KEY_CUSTOM_ICONS), icon => _.get(icon, 'iconDetail.isPackagingAllowed'));
    return _.map(packagingIcons, icon => this._toIcon(icon, { tankType: 'BT' }, mapping)).sort((a, b) => {
        const idA = get(a, 'id');
        const idB = get(b, 'id');
        const displayNameA = get(a, 'displayName');
        const displayNameB = get(b, 'displayName');

        // Keep the object with id 1 at the start
        if (idA === 1) {
            return -1; // Keep a before b
        } else if (idB === 1) {
            return 1; // Move b before a
        } else {
            // Sort the rest alphabetically by display name
            return displayNameA.localeCompare(displayNameB);
        }
    });
  },

  _toIcon(icon, overrideAttributes, mapping) {
    return _.merge({
      id: icon.id,
      name: _.trim(_.get(icon, 'iconDetail.name')),
      displayName: mapping[_.trim(_.get(icon, 'iconDetail.displayName'))] || _.trim(_.get(icon, 'iconDetail.displayName')),
      src: _.get(icon, 'iconDetail.urlImage'),
      iconClassName: _.trim(`icon-task ${_.get(icon, 'iconDetail.iconClassName')}`)
    }, overrideAttributes);
  },

  tryFVicons(item, icons) {
    icons = DashboardServiceCache.getFermenterIconsWithLegacy();
    item.icon = _.find(
      icons,
      (icon) =>
        icon.displayName === get(item, 'displayName') ||
        icon.displayName === get(item, 'name') ||
        icon.displayName === get(item, 'task', get(item, 'name')) ||
        icon.name === get(item, 'name') ||
        icon.name === get(item, 'displayName') ||
        icon.name === get(item, 'task', get(item, 'name'))
    );
  },

  tryBTicons(item, icons) {
    icons = DashboardServiceCache.getPackagingIconsWithLegacy();
    item.icon = _.find(
      icons,
      (icon) =>
        icon.displayName === get(item, 'displayName') ||
        icon.displayName === get(item, 'name') ||
        icon.displayName === get(item, 'task', get(item, 'name')) ||
        icon.name === get(item, 'name') ||
        icon.name === get(item, 'displayName') ||
        icon.name === get(item, 'task', get(item, 'name'))
    );
  },

  tryBHicons(item, icons) {
    icons = DashboardServiceCache.getBrewhouseIconsWithLegacy();
    item.icon = _.find(
      icons,
      (icon) =>
        icon.displayName === get(item, 'displayName') ||
        icon.displayName === get(item, 'name') ||
        icon.displayName === get(item, 'task', get(item, 'name')) ||
        icon.name === get(item, 'name') ||
        icon.name === get(item, 'displayName') ||
        icon.name === get(item, 'task', get(item, 'name'))
    );
  },

  hydrateWithIcon(item, tankType, requestedFrom, icons) {
    if (!item) {
      return item;
    }
    // Find icon corresponding with the Name, DisplayName or Task Name of the item
    if (requestedFrom === 'dashboard') {
      item.icon = _.find(
        icons,
        (icon) =>
          icon.displayName === get(item, 'displayName') ||
          icon.displayName === get(item, 'name') ||
          icon.displayName === get(item, 'task', get(item, 'name')) ||
          icon.name === get(item, 'name') ||
          icon.name === get(item, 'displayName') ||
          icon.name === get(item, 'task', get(item, 'name'))
      );

      // IF NOT FOUND IN THE TANKTYPE RECIVED FIND EVERYWHERE
      if (item.icon === undefined) {
        if (tankType !== 'FV') {
          this.tryFVicons(item, icons);
        }

        if (item.icon === undefined) {
          if (tankType !== 'BT') {
            this.tryBTicons(item, icons);
          }
        }

        if (item.icon === undefined) {
          if (tankType !== 'BH') {
            this.tryBHicons(item, icons);
          }
        }
      }

      // If icon not found need to return undefined to prevent non existent icon
      if (item.icon === undefined && requestedFrom === 'dashboard') {
        return undefined;
      }
    } else {
      item.icon = _.find(
        icons,
        (icon) =>
          icon.displayName === get(item, 'typeTask') ||
          icon.name === get(item, 'typeTask')
      );
    }

    return item;
  },

  getFermenterIcons() {
    return this.getCustomFermenterIcons();
  },

  getPackagingIcons() {
    return this.getCustomPackagingIcons();
  },

  getBrewhouseIcons() {
    return this.getCustomBrewingIcons();
  },

  findIconByDisplayName(displayName) {
    let iconTarget = _.find(this.getFermenterIcons(), icon => icon.displayName === displayName);
    if (iconTarget) {
      return iconTarget;
    }

    iconTarget = _.find(this.getPackagingIcons(), icon => icon.displayName === displayName);
    if (iconTarget) {
      return iconTarget;
    }

    iconTarget = _.find(this.getBrewhouseIcons(), icon => icon.displayName === displayName);
    if (iconTarget) {
      return iconTarget;
    }

    return null;
  },

  /**
   * Retrieve the task by their type.
   * @param {String} type
   * @return {Array}
   */
  getTasksByType(typeTask) {
    if (typeTask === Constants.TYPE_TANK_FERMENTER) {
      return this.getFermenterIcons();
    } else if (typeTask === Constants.TYPE_TANK_BRITE_TANK) {
      return this.getPackagingIcons();
    } else if (typeTask === Constants.TYPE_TANK_BREW_HOUSE) {
      return this.getBrewhouseIcons();
    }
  },

  getIconsByType(type) {
    if (type === FERMENTER_TYPE_TASK || type === 'FV') {
      return this.getFermenterIcons();
    } else if (type === PACKAGING_TYPE_TASK || type === 'BT') {
      return this.getPackagingIcons();
    } else if (type === BREWING_TYPE_TASK || type === 'BH') {
      return this.getBrewhouseIcons();
    }
  },

  /**
   * Retrieve the current cache orders.
   * @returns {*|Array}
   */
  getOrders() {
    return ContentUtils.getMemory(KEY_ORDER) || [];
  },

  getOrdersByBatchNumber(batchNumber) {
    return _.filter(this.getOrders(), order => _.get(order, 'batchNumber') === batchNumber);
  },

  getOrdersSorted() {
    const orders = this.getOrders() || [];
    return orders.sort((order, orderCompare) => {
      let field;

      if (order && order.isSingle) {
        field = 'fromDate';
      } else {
        field = 'brewDate';
      }

      if (DateUtils.isAfter(order[field], orderCompare[field])) {
        return 1;
      }
      if (DateUtils.isBefore(order[field], orderCompare[field])) {
        return -1;
      }
      return 0;
    });
  },

  getSafeOrder(orderId) {
    if (!orderId) {
      return null;
    }

    const orderIdCleaned = ContentUtils.cleanId(orderId);

    return _.cloneDeep(this.getOrder(orderIdCleaned));
  },

  /**
   * Retrieve the specific order by their id.
   * @param id
   * @returns {*}
   */
  getOrder(id) {
    var order = this.getOrders().filter(function (order) {
      return order.id === id;
    });

    if (order && order.length === 1) {
      return _.clone(order[0]);
    } else {
      return null;
    }
  },

  /**
   * Remove the given cache orders.
   * @param id
   */
  removeOrder(id) {
    const targetId = ContentUtils.cleanId(id);
    var restOfOrders = this.getOrders().filter(function (order) {
      return ContentUtils.cleanId(order.id) !== targetId;
    });


    ContentUtils.saveMemory(KEY_ORDER, restOfOrders);

    // remove order from layout
    DashboardLayoutStore.removeByOrderId(targetId);
  },

  /**
   * Add new orders and remove the older.
   * @param orders
   */
  setOrders(orders) {
    this.clearOrderCache();
    this.addOrders(orders);
  },


  /**
   * Add a new orders in draft mode in local cache.
   * @param orders
   */
  addOrders(orders) {
    var self = this;
    _.forEach(orders, function (order) {
      self.addOrder(order);
    });
  },

  /**
   * Add a new order in draft mode in local cache and assign temporary
   * id that will be remplace when the order will be pushed in the server side.
   * @param newOrder
   * @returns {*}
   */
  addOrder(newOrder) {
    var orders = this.getOrders();
    if (newOrder && !newOrder.id) {
      newOrder.id = this._getTemporaryId();
    }
    orders.push(_.clone(newOrder));
    ContentUtils.saveMemory(KEY_ORDER, orders);

    return this.getOrder(newOrder.id);
  },

  /**
   * Add a new Single order in draft mode in local cache and assign temporary
   * id that will be remplace when the order will be pushed in the server side.
   * @param newOrder
   * @returns {*}
   */
  addSingleOrder(newSingleOrder) {
    var orders = this.getOrders();
    if (newSingleOrder && !newSingleOrder.id) {
      newSingleOrder.id = this._getTemporaryId();
    }
    orders.push(_.clone(newSingleOrder));
    ContentUtils.saveMemory(KEY_ORDER, orders);

    return this.getOrder(newSingleOrder.id);
  },

  /**
   * Change the given order in local cache.
   * @param newOrder
   */
  changeOrder(newOrder) {
    const restOfOrders = this.getOrders().filter(function (order) {
      return order.id !== newOrder.id;
    });
    restOfOrders.push(_.clone(newOrder));
    ContentUtils.saveMemory(KEY_ORDER, restOfOrders);
  },

  /**
   * Override or set the existent orders draft.
   */
  setDraft(draft) {
    ContentUtils.saveSession(KEY_DRAFT, draft);
  },

  updateDraft(draft) {
    const pendingOperations = this.getPendingOperations();
    const havePendingOperation = ContentUtils.isNotEmptyArray(pendingOperations);

    if (havePendingOperation) {
      this.setDraft(draft);
      for (const operation of pendingOperations) {
        this.addOperation(operation);
      }
    } else {
      this.setDraft(draft);
    }
  },

  /**
   * Retrieve the operation of current draft.
   */
  getOperations() {
    return this.getDraft().operations || [];
  },

  /**
   * Retrieve the redo operation of current draft.
   */
  getRedoOperations() {
    return this.getDraft().redoOperations || [];
  },

  /**
   * Retrieve the redo operation of current draft.
   */
  undoOperations() {
    return this.getDraft().undoOperations || [];
  },

  /**
   * Retrieve the pending operation that dont was saved in the backend side.
   * @returns {*|Array}
   */
  getPendingOperations() {
    return _.filter(this.getDraft().operations, operation => !operation.isSaved);
  },
  /**
   * Retrieve the pending operation that dont was saved in the backend side.
   * @returns {*|Array}
   */
  getNonPendingOperations() {
    return _.filter(this.getDraft().operations, operation => operation.isSaved);
  },

  /**
   * Retrieve if exist pending operation or not.
   * @returns {boolean}
   */
  isAllOperationAlreadySaved() {
    return this.getPendingOperations().length === 0;
  },

  /**
   * Retrieve the current draft, if doesn't not exist, create an empty one and then return them.
   */
  getDraft() {
    const draft = ContentUtils.getSession(KEY_DRAFT);
    if (!draft || ContentUtils.isEmptyArray(get(draft, 'operations'))) {
      this._initEmptyDraft();
    }
    return ContentUtils.getSession(KEY_DRAFT);
  },

  /**
   * Update the tanks from the cache.
   * @param tanks
   */
  setTanks(tanks) {
    ContentUtils.saveSession(KEY_TANK, tanks);
  },

  /**
   * Retrieve the cache sorted tanks.
   * @returns {*|Array}
   */
  getTanks() {
    let tanks;
    tanks = ContentUtils.getSession(KEY_TANK) || [];
    return ContentUtils.sortTanksAndAddColumn(tanks);
  },

  getCurrentUnitTank() {
    return _.get(this.getTanks(), '0.unit') || Constants.DEFAULT_TANK_UNIT;
  },

  /**
   * Retrieve tank by column.
   * @param column
   * @returns {*}
   */
  getTankByColumn(column) {
    const tank = this.getTanks().filter(function (tank) {
      return tank.column === column;
    })[0];
    return tank;
  },

  /**
   * Add a new operation to the current draft.
   * @param operation
   */
  addOperation(operation) {
    const draft = this.getDraft(KEY_DRAFT);
    operation.indexDraft = moment().unix();
    if (draft.operations.length <= MAX_DRAFT_OPERATION) {
      draft.operations.push(operation);
      this.setDraft(draft);
    } else {
      CustomDialog.showWarningConfirmation(t('warning'), t('notification_draft_maximum_capacity_wait_a moment_or_publish'), () => {
        DashboardAction.publishingDraft();
      });
      setTimeout(() => {
        DashboardAction.hideLoading();
      }, 2000);
    }
  },

  /**
   * Mark as save given operations.
   */
  markAsSavedOperationsUntilIndex(operationsSaved = []) {
    const lastIndexDraftSaved = operationsSaved
      .map(op => +op.indexDraft)
      .sort((a, b) => a - b).pop();

    const draft = this.getDraft();
    draft.operations = _.map(draft.operations, function (operation) {
      operation.isSaved = operation.indexDraft <= lastIndexDraftSaved;
      return operation;
    });
    this.setDraft(draft);
  },

  cleanSavedOperations() {
    const draft = this.getDraft();
    draft.operations = _.filter(draft.operations, operationSaved => !operationSaved.isSaved);
    this.setDraft(draft);
  },

  /**
   * Clean all the cache about orders, tanks & drafts too.
   */
  clearAllCache(isTesting) {
    if (isTesting) {
      ContentUtils.saveMemory(KEY_TANK, []);
    } else {
      ContentUtils.saveSession(KEY_TANK, []);
    }
    ContentUtils.saveMemory(KEY_ORDER, []);
    ContentUtils.saveSession(KEY_DRAFT, []);
    ContentUtils.saveSession(KEY_BEER_STYLE, []);
    ContentUtils.saveSession(Constants.KEY_LOCATION_ITEMS, []);
    ContentUtils.saveSession(Constants.KEY_LOCATION, []);
    ContentUtils.saveSession(Constants.KEY_CUSTOM_ICONS, []);
    ContentUtils.saveMemory(Constants.KEY_PRODUCT_ICONS, []);
    ContentUtils.saveMemory(Constants.KEY_PRODUCT_ITEMS, []);
    ContentUtils.saveSession(Constants.KEY_PRODUCTS, []);
    ContentUtils.saveSession(Constants.KEY_FERMENTING_PROCESS, []);
    ContentUtils.saveSession(Constants.KEY_PACKAGING_PROCESS, []);
    ContentUtils.saveSession(Constants.KEY_BREW_PROCESS, []);
    ContentUtils.saveSession(Constants.KEY_ITEMS, []);
    ContentUtils.saveSession(Constants.KEY_VENDOR_PURCHASE_ITEMS, []);
    ContentUtils.saveSession(Constants.KEY_VENDOR_ITEMS, []);
    ContentUtils.saveSession(Constants.KEY_BEER_STYLE_TASK_CONFIGURATIONS, []);
  },

  /**
   * Clean only orders cache.
   */
  clearOrderCache() {
    ContentUtils.saveMemory(KEY_ORDER, []);
  },

  /**
   * Clean operation of current draft, if it doesn't exit create a new one, and
   * set as empty their operations.
   */
  cleanOperations() {
    const draft = this.getDraft();
    draft.operations = draft.operations.filter(operation => !operation.isSaved); // left only not saved operation.
    this.setDraft(draft);
  },

  getProcessByType(type) {
    switch (type) {
      case Constants.TYPE_TANK_FERMENTER:
        return this.getFermentingProcess();
      case Constants.TYPE_TASK_FERMENTER:
        return this.getFermentingProcess();
      case Constants.TYPE_TASK_BREWHOUSE:
        return this.getBrewingProcess();
      case Constants.TYPE_TANK_BREW_HOUSE:
        return this.getBrewingProcess();
      case Constants.TYPE_TANK_BRITE_TANK:
        return this.getPackagingProcess();
      case Constants.TYPE_TASK_PACKAGING:
        return this.getPackagingProcess();
    }
  },

  getBrewingProcess() {
    return ContentUtils.getSession(KEY_BREW_PROCESS) || [];
  },

  getFermentingProcess() {
    return ContentUtils.getSession(KEY_FERMENTING_PROCESS) || [];
  },

  getPackagingProcess() {
    return ContentUtils.getSession(KEY_PACKAGING_PROCESS) || [];
  },

  getReservationItem() {
    //TODO: WIP...
    return [];
  },

  _setIcons(icons, iconsFromApplicant) {
    const iconsWithApplicantIcons = ContentUtils.formatApplicantIcons(icons, iconsFromApplicant);
    ContentUtils.saveSession(Constants.KEY_CUSTOM_ICONS, iconsWithApplicantIcons);
  },

  _setProductIcons(productIcons) {
    ContentUtils.saveMemory(Constants.KEY_PRODUCT_ICONS, productIcons);
  },

  _hydrateWithProduct(productDry, products) {
    const haveProductIcons = ContentUtils.isNotEmptyArray(productDry) && ContentUtils.isNotEmptyArray(products);
    if (haveProductIcons) {
      return _.map(productDry, productDry => {
        const isDryProduct = productDry && productDry.product != undefined && typeof productDry.product === 'number';
        if (isDryProduct) {
          const productTarget = _.find(products, product => product.id === productDry.product);
          if (productTarget) {
            productDry.product = productTarget;
          }
        }
        return productDry;
      });
    }

    return productDry;
  },

  _setProductItems(productItems) {
    ContentUtils.saveMemory(Constants.KEY_PRODUCT_ITEMS, productItems);
  },

  _setLocationItems(locationItems) {
    ContentUtils.saveSession(Constants.KEY_LOCATION_ITEMS, locationItems);
  },

  _setProducts(products) {
    ContentUtils.saveSession(Constants.KEY_PRODUCTS, products);
  },

  _setLocations(locations) {
    ContentUtils.saveSession(KEY_LOCATIONS, locations);
  },

  getIcons() {
    return ContentUtils.getSession(Constants.KEY_CUSTOM_ICONS);
  },

  getLocations() {
    return ContentUtils.getSession(KEY_LOCATIONS);
  },

  getProducts() {
    return ContentUtils.getSession(Constants.KEY_PRODUCTS);
  },

  getProductsByBeerStyle(beerStyleId) {
    const allProducts = this.getProducts();
    return _.filter(allProducts, product => (+_.get(product, 'beerStyle.id')) === (+beerStyleId));
  },

  getProductItemsByProducts(products) {
    const allProductItems = this.getProductItems();
    const productsId = _.map(products, product => product.id);
    return _.filter(allProductItems, productItem => productsId.includes((+_.get(productItem, 'product.id'))));
  },

  getLocationItems() {
    return ContentUtils.getSession(Constants.KEY_LOCATION_ITEMS);
  },

  getProductIcons() {
    return ContentUtils.getMemory(Constants.KEY_PRODUCT_ICONS);
  },

  getProductIconsProducts(products) {
    const allProductIcons = this.getProductIcons();
    const productsId = _.map(products, product => product.id);
    return _.filter(allProductIcons, productIcon => productsId.includes((+_.get(productIcon, 'product.id'))));
  },


  getProductByIconNameEnables(taskName) {
    return _.filter(this.getProductByIconName(taskName), productIcon => get(productIcon, 'enable'));
  },

  getProductByIconName(taskName) {
    const productIcons = this.getProductIcons();
    if (ContentUtils.isNotEmptyArray(productIcons)) {
      const productIconsFiltered = _.filter(productIcons, pi =>
        get(pi, 'icon.iconDetail.name') === taskName ||
        get(pi, 'icon.iconDetail.displayName') === taskName
      );
      if (ContentUtils.isNotEmptyArray(productIconsFiltered)) {
        const productMayRepeated = _.map(productIconsFiltered, productIcon => productIcon.product);
        const productHydrated = _.map(productMayRepeated, product => this.getProductById(get(product, 'id')));
        return ContentUtils.removeDuplicateByAttribute(productHydrated, ['id']);
      }
    }
  },

  getProductItems() {
    return ContentUtils.getMemory(Constants.KEY_PRODUCT_ITEMS);
  },

  getLocationItemByLocationIdAndItemId(locationId, itemId) {
    return _.find(this.getLocationItems(), locationItem => get(locationItem, 'item.id') === itemId && get(locationItem, 'location.id') === locationId);
  },

  getLocationItemByItemId(locationId, itemId) {
    return _.find(this.getLocationItems(), locationItem => get(locationItem, 'item.id') === itemId);
  },

  getProductItemsByProductId(productId) {
    return _.filter(this.getProductItems(), productItem => _.get(productItem, 'product.id') === productId);
  },

  getProductItemsByProductIdAndItemId(productId, itemId) {
    return _.find(this.getProductItems(), productItem => _.get(productItem, 'product.id') === productId && _.get(productItem, 'item.id') === itemId);
  },

  getProductById(productId) {
    return _.find(DashboardServiceCache.getProducts(), productPristine => productId === get(productPristine, 'id'));
  },

  getProductByName(productName) {
    return _.find(DashboardServiceCache.getProducts(), productPristine => productName === get(productPristine, 'name'));
  },

  /**
   * Initialize the whole cache content to allow render the Dashboard Page.
   * @param dashboardContent
   */
  fillCache(dashboardContent) {
    // Sort tanks and add Column attributes and then save Tanks.
    const tanksSortedWithColumns = ContentUtils.sortTanksAndAddColumn(dashboardContent.tanks);
    this.setTanks(tanksSortedWithColumns);

    // Save all kind of process such as Brewing, Fermenting and Packaging order process.
    this._addTask(dashboardContent.process);

    // Save Style Beers
    this._setBeerStyles(_.orderBy(dashboardContent.styleBeers, 'name'));

    // Save Beer Style Task Configurations
    this._setBeerStyleConfiguration(dashboardContent.styleBeerConfiguration);

    // Save the current version from each of Poll.
    SessionStore.setLastPublishVersion(dashboardContent.lastPublicationNumber);
    SessionStore.setLastBrewingNoteNumber(dashboardContent.lastBrewingNoteNumber);
    SessionStore.setLastPackagingNoteNumber(dashboardContent.lastPackagingNoteNumber);
    SessionStore.setCurrentAppVersion(dashboardContent.lastAppVersion);
    SessionStore.setLastPublicationAdminNumber(dashboardContent.lastPublicationAdminNumber);
    SessionStore.setLastChangeUserToken(dashboardContent.lastChangeUserToken);
    if (dashboardContent.lastBatchNumberOrder) {
      SessionStore.setLastBatchNumber(dashboardContent.lastBatchNumberOrder);
    }
    // Fill cache Notes from Chronologyc bar
    ChronologycServiceCache.fillBrewingNoteCache(dashboardContent.brewingNotes);
    ChronologycServiceCache.fillPackagingNoteCache(dashboardContent.packagingNotes);
    // Fill cache about applicantConfiguration
    SessionStore.setApplicantPhone(get(dashboardContent, 'applicantConfigurationDetail.applicantPhone'));
    SessionStore.setApplicantEmail(get(dashboardContent, 'applicantConfigurationDetail.email'));
    SessionStore.setApplicantAddress(get(dashboardContent, 'applicantConfigurationDetail.applicantAddress'));
    SessionStore.setApplicantCityAndState(get(dashboardContent, 'applicantConfigurationDetail.applicantCityAndState'));
    SessionStore.setApplicantTaxId(get(dashboardContent, 'applicantConfigurationDetail.applicantTaxId'));
    // Section visibility filter
    SessionStore.setIsVisibleBrewingSection(get(dashboardContent, 'applicantConfigurationDetail.isVisibleBrewingSection'));
    SessionStore.setIsVisibleFermentingSection(get(dashboardContent, 'applicantConfigurationDetail.isVisibleFermentingSection'));
    SessionStore.setIsVisiblePackagingSection(get(dashboardContent, 'applicantConfigurationDetail.isVisiblePackagingSection'));
    // BeerStyle label section filter
    SessionStore.setIsVisibleBeerStyleLabelBrewing(get(dashboardContent, 'applicantConfigurationDetail.isVisibleBeerNameBrewingSection'));
    SessionStore.setIsVisibleBeerStyleLabelFermenting(get(dashboardContent, 'applicantConfigurationDetail.isVisibleBeerNameFermentingSection'));
    SessionStore.setIsVisibleBeerStyleLabelPackaging(get(dashboardContent, 'applicantConfigurationDetail.isVisibleBeerNamePackagingSection'));
  },


  fillCacheInventoryItems(dashboardContent) {
    // Save custom configuration of icons, applicantIcons & Products configuration
    this._setIcons(dashboardContent.icons, dashboardContent.applicantIcons);
    this._setLocations(dashboardContent.locations);
    this._setLocationItems(dashboardContent.locationItems);
    this._setItems(dashboardContent.items);
    this._setVendorPurchaseItems(dashboardContent.vendorPurchaseItem);
    this._setVendorItems(dashboardContent.vendorItems);
    this._setLocationInformation(dashboardContent);
  },

  fillCacheInventoryProducts(dashboardContent) {
    // Save custom configuration of icons, applicantIcons & Products configuration
    const productIconHydrated = this._hydrateWithProduct(dashboardContent.productIcons, dashboardContent.products);
    this._setProductIcons(productIconHydrated);
    const productItemsHydrated = this._hydrateWithProduct(dashboardContent.productItems, dashboardContent.products);
    this._setProductItems(productItemsHydrated);
    this._setProducts(dashboardContent.products);
  },

  fillCacheOrder(orders) {
    const self = this;
    // Fill the tank of each order.
    orders = this.hydratedOrdersWithTanks(orders, this.getTanks());

    // Fill the style beer of each order.
    orders = this.hydratedOrdesWithBeerStyles(orders, this.getBeerStyles());

    // Fill the style beer of each order.
    orders = this.hydratedOrdersWithProducts(orders, this.getProducts());

    // clean order list
    ContentUtils.saveMemory(KEY_ORDER, []);

    // Add all existent order from the server, that could be already hydrated.
    _.forEach(orders, function (order) {
      self.addOrder(order);
    });

    // validate if while saving draft, don't have any new operation without saved yet
    // so hydrate until save the next pendings operation
    const pendingOperations = this.getPendingOperations();
    if (ContentUtils.isNotEmptyArray(pendingOperations)) {
      this._hydrateWithLastestNonSavedOperations(pendingOperations);
    }

    return orders;
  },

  _hydrateWithLastestNonSavedOperations(pendingOperations) {
    if (ContentUtils.isNotEmptyArray(pendingOperations)) {
      const self = this;
      _.forEach(pendingOperations, operation => {
        const operationType = get(operation, 'typeOperation');
        switch (operationType) {
          case 'NEW_ORDER': {
            self.addOrder(get(operation, 'order'));
            break;
          }
          case 'CHANGE_ORDER': {
            const existingOrder = this.getOrders();
            if (existingOrder) {
              self.changeOrder(operation.order);
            } else {
              self.addOrder(get(operation, 'order'));
            }
            break;
          }
          case 'DELETE_ORDER': {
            self.removeOrder(get(operation, 'order.id'));
            break;
          }
        }
      });
    }
  },

  _setItems(items) {
    ContentUtils.saveSession(KEY_ITEMS, items);
  },

  getItems() {
    return ContentUtils.getSession(KEY_ITEMS);
  },

  getItemById(itemId) {
    return _.find(ContentUtils.getSession(KEY_ITEMS), item => item.id === itemId);
  },

  _setVendorPurchaseItems(vendorPurchaseItems) {
    ContentUtils.saveSession(KEY_VENDOR_PURCHASE_ITEMS, vendorPurchaseItems);
  },

  getVendorPurchaseItems() {
    return ContentUtils.getSession(KEY_VENDOR_PURCHASE_ITEMS);
  },

  _setVendorItems(vendorItems) {
    ContentUtils.saveSession(KEY_VENDOR_ITEMS, vendorItems);
  },

  getVendorItems() {
    return ContentUtils.getSession(KEY_VENDOR_ITEMS);
  },

  _setLocationInformation() {
    //const country = get(dashboardContent, 'country') || DashboardServiceCache.getCurrentCountry();
    //SessionStore.setCurrentCountry(country);
  },

  _setBrewhouseProcess(brewProcess) {
    ContentUtils.saveSession(KEY_BREW_PROCESS, brewProcess);
  },

  _addTask(processList) {
    ContentUtils.saveSession(KEY_FERMENTING_PROCESS, _.filter(processList, process => process.processSection === Constants.FERMENTING_SECTION_NAME));
    ContentUtils.saveSession(KEY_PACKAGING_PROCESS, _.filter(processList, process => process.processSection === Constants.PACKAGING_SECTION_NAME));
    ContentUtils.saveSession(KEY_BREW_PROCESS, _.filter(processList, process => process.processSection === Constants.BREWING_SECTION_NAME));
  },

  _setBeerStyleConfiguration(tasks) {
    ContentUtils.saveSession(KEY_BEER_STYLE_TASK_CONFIGURATIONS, tasks);
  },

  getBeerStyleTaskConfiguration() {
    return ContentUtils.getSession(KEY_BEER_STYLE_TASK_CONFIGURATIONS);
  },

  getBeerStyleTaskConfigurationByBeerStyle(beerStyleId) {
    const configurations = this.getBeerStyleTaskConfiguration();
    return _.filter(configurations, configuration => get(configuration, 'styleBeerId') === beerStyleId);
  },

  /**
   * Given orders and tanks, fill each order with the proper tank information.
   * @param {Array} orders
   * @param {Array} tanksToSave
   * @returns {*}
   */
  hydratedOrdersWithTanks(orders, tanks) {
    let briteTankOrder,
      fermenterTankOrder,
      singleTankOrder;
    return _.map(orders, order => {
      if (order.isSingle) {
        singleTankOrder = _.find(tanks, tank => String(tank.id) === String(order.singleTankId));
        order.singleTank = singleTankOrder;
      } else {
        briteTankOrder = _.find(tanks, tank => String(tank.id) === String(order.briteTankId));
        fermenterTankOrder = _.find(tanks, tank => String(tank.id) === String(order.fermenterTankId));
        order.fermenterTank = fermenterTankOrder;
        order.briteTank = briteTankOrder;
      }
      order = this.hydratedOrderWithBatchs(order, tanks);
      return order;
    });
  },

  /**
   * Given order and tanks, hydrated with turns each batch if needed.
   * @param order
   * @param tanks
   * @return {*}
   */
  hydratedOrderWithBatchs(order, tanks) {
    if (order && order.batchs) {
      order.batchs = _.map(order.batchs, batch => {
        batch.turn = _.find(tanks, tank => tank.id === batch.turnId);
        return batch;
      });
    }
    return order;
  },

  /**
   * Given orders and style beers fill each order with the proper style beer information.
   * @param {Array} orders
   * @param {Array} tanksToSave
   * @returns {*}
   */
  hydratedOrdesWithBeerStyles(orders, styleBeers) {
    let styleBeer;
    return _.map(orders, order => {
      styleBeer = _.find(styleBeers, styleBeer => String(styleBeer.id) === String(order.styleBeerId));
      order.styleBeer = styleBeer;
      return order;
    });
  },

  hydratedOrdersWithProducts(orders, products) {
    return _.map(orders, order => {
      if (order) {
        if (order.isSingle) {
          order.singleTasks = _hydrateProductTask(order.singleTasks, products);
        } else {
          order.fermenterTasks = _hydrateProductTask(order.fermenterTasks, products);
          order.packagingTasks = _hydrateProductTask(order.packagingTasks, products);
          order.batchs = _hydrateProductTask(order.batchs, products);
        }
      }
      return order;
    });
  },

  getLatestBatchNumber() {
    // get last batch number from the server
    const lastBatchNumberSavedFromServer = SessionStore.getLastBatchNumber();

    // get the last batch number from the client
    const localBatchNumber = get(_.maxBy(this.getOrders(), order => this._getNumber(order)), 'batchNumber', '');

    return NumberUtils.isGreater(lastBatchNumberSavedFromServer, localBatchNumber) ? lastBatchNumberSavedFromServer : localBatchNumber;
  },

  _getNumber(order) {
    if (!order) {
      return 0;
    }
    const batchNumber = _.get(order, 'batchNumber', '');
    if (batchNumber && batchNumber.match) {
      return +_.join(batchNumber.match(/[\d]/gi), '');
    } else {
      return 0;
    }
  },

  /**
   * Save locally the style beers.
   * @param styleBeer
   * @private
   */
  _setBeerStyles(styleBeer) {
    ContentUtils.saveSession(KEY_BEER_STYLE, styleBeer);
  },

  /**
   * Retrieve the cache style beer.
   * @returns {*}
   */
  getBeerStyles() {
    return ContentUtils.getSession(KEY_BEER_STYLE);
  },

  /**
   * The temporary identifier to handler the new orders.
   * @returns {string}
   * @private
   */
  _getTemporaryId() {
    return Constants.DRAFT_ORDER_PREFIX.toString() + Math.random();
  },

  /**
   * Initialize an empty draft.
   * @private
   */
  _initEmptyDraft() {
    this.setDraft({
      applicant: SessionStore.getCurrentApplicant(),
      operations: []
    });
  },

  /**
   * Order the tanks against the number of column asc order.
   * @argument {Tank} tankA
   * @argument {Tank} TankB
   * @return {Number}
   */
  _prioritizeTank(tankA, tankB) {
    const comlumnOne = tankA.name.match((/\d+/));
    const comlumnTwo = tankB.name.match((/\d+/));
    return comlumnOne - comlumnTwo;
  },

  updateOrder(newOrder) {
    let restOfOrders = (ContentUtils.getMemory(KEY_ORDER) || []).filter(function (order) {
      return order.id !== newOrder.id;
    });
    restOfOrders.push(newOrder);
    ContentUtils.saveMemory(KEY_ORDER, restOfOrders);
  },

  setDraftOrderAmount(draftOrderAmount) {
    ContentUtils.saveLocal(KEY_DRAFT_ORDER_AMOUNT, draftOrderAmount);
  },

  setUndoDraftOrderAmount(undoDraftOrderAmount) {
    ContentUtils.saveLocal(KEY_UNDO_DRAFT_ORDER_AMOUNT, undoDraftOrderAmount);
  },

  getDraftOrderAmount() {
    return ContentUtils.getLocal(KEY_DRAFT_ORDER_AMOUNT) || 0;
  },

  getUndoDraftOrderAmount() {
    return ContentUtils.getLocal(KEY_UNDO_DRAFT_ORDER_AMOUNT) || 0;
  }

};

function _hydrateProductTask(tasks, products) {
  if (ContentUtils.isNullOrEmpty(tasks)) {
    return tasks;
  }

  return _.map(tasks, task => {
    if (task && ContentUtils.isNotEmptyArray(task.products)) {
      task.products = _.map(task.products, product => {
        const productTarget = _.find(products, productSearch => _.get(productSearch, 'id') === _.get(product, 'id'));
        if (productTarget) {
          product.category = productTarget.category;
          product.name = productTarget.name;
          product.amountDefault = productTarget.amount;
          // make immutable field
          Object.defineProperty(product, 'amountDefault', {
            configurable: false,
            writable: false,
            enumerable: true
          });
        }
        return product;
      });
    }
    return task;
  });
}

module.exports = DashboardServiceCache;



/** WEBPACK FOOTER **
 ** ./src/services/DashboardServiceCache.js
 **/